import { EGroupedItemsType } from '~/src/services/properties';

export const blockConfig = {
    label: {
        name: 'label',
        label: 'Заголовок',
        type: EGroupedItemsType.Title,
    },
    properties: {
        name: 'properties',
        items: {
            addElement: {
                name: 'addElement',
                label: 'Добавить элемент',
                type: EGroupedItemsType.Button,
                order: 1,
            },
            columnCount: {
                name: 'columnCount',
                label: 'Количество колонок в ряд',
                type: EGroupedItemsType.Select,
                order: 3,
                withBreakpoints: true,
            },
            imageColumnCount: {
                name: 'imageColumnCount',
                label: 'Количество изображений в ряд',
                type: EGroupedItemsType.Select,
                order: 3,
                withBreakpoints: true,
            },
            showBundles: {
                name: 'showBundles',
                label: 'Показать тарифы КП',
                type: EGroupedItemsType.Boolean,
                order: 3,
            },
            showDiscount: {
                name: 'showDiscount',
                label: 'Показать акцию 1 рубль',
                type: EGroupedItemsType.Boolean,
                order: 2,
            },
            bundlesAliases: {
                name: 'bundlesAliases',
                label: 'Фильтр КП',
                type: EGroupedItemsType.AliasFilter,
                order: 3,
            },
            showInternet: {
                name: 'showInternet',
                label: 'Показать тарифы Интернет',
                type: EGroupedItemsType.Boolean,
                order: 3,
            },
            internetAliases: {
                name: 'internetAliases',
                label: 'Фильтр Интернет',
                type: EGroupedItemsType.AliasFilter,
                order: 3,
            },
            aliasWildcard: {
                name: 'aliasWildcard',
                label: 'Alias wildcard',
                type: EGroupedItemsType.String,
                order: 3,
            },
            fixedImages: {
                name: 'fixedImages',
                label: 'Фиксировать изображения',
                type: EGroupedItemsType.Boolean,
                order: 3,
            },
            customStyles: {
                name: 'customStyles',
                label: 'Расширенные CSS-стили:',
                type: EGroupedItemsType.Text,
                order: 4,
                withBreakpoints: true,
            },
            sortOrder: {
                name: 'sortOrder',
                label: 'Сортировка',
                type: EGroupedItemsType.String,
                order: 5,
            },
            background: {
                name: 'background',
                label: 'Фон',
                type: EGroupedItemsType.File,
                order: 3,
            },
            backgroundWebp: {
                name: 'webp',
                type: EGroupedItemsType.Hidden,
            },
            backgroundColor: {
                name: 'backgroundColor',
                label: 'Цвет фона',
                type: EGroupedItemsType.ColorPicker,
                order: 3,
            },
            blockName: {
                name: 'blockName',
                label: 'Название блока',
                type: EGroupedItemsType.String,
                order: 3,
            },
            alignTabs: {
                name: 'alignTabs',
                label: 'Вкладки по центру',
                type: EGroupedItemsType.Boolean,
                order: 3,
            },
            marginTop: {
                name: 'marginTop',
                label: 'Отступ сверху',
                type: EGroupedItemsType.Margin,
                order: 4,
                withBreakpoints: true,
            },
            marginBottom: {
                name: 'marginBottom',
                label: 'Отступ снизу',
                type: EGroupedItemsType.Margin,
                order: 4,
                withBreakpoints: true,
            },
            blockWidth: {
                name: 'blockWidth',
                label: 'Ширина блока с тектом (px или %):',
                type: EGroupedItemsType.String,
                order: 4,
                withBreakpoints: true,
            },
            imagePlacement: {
                name: 'imagePlacement',
                label: 'Расположить картинку',
                type: EGroupedItemsType.Select,
                order: 4,
                withBreakpoints: true,
            },
            isAutoHeightSize: {
                name: 'isAutoHeightSize',
                label: 'Автоматическая высота блока',
                type: EGroupedItemsType.Boolean,
                order: 3,
            },
            isVertical: {
                name: 'isVertical',
                label: 'Вертикальный шаблон',
                type: EGroupedItemsType.Boolean,
                order: 3,
            },
            isDarkTheme: {
                name: 'isDarkTheme',
                label: 'Тёмная тема',
                type: EGroupedItemsType.Boolean,
                order: 3,
            },
            isFullByActive: {
                name: 'isFullByActive',
                label: 'Включить ПП',
                type: EGroupedItemsType.Boolean,
                order: 3,
            },
            isCarouselActive: {
                name: 'isCarouselActive',
                label: 'Включить карусель',
                type: EGroupedItemsType.Boolean,
                order: 3,
            },
        },
    },
};
